import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import toast from "react-hot-toast";
import icons from "../../../assets/images/constantIcons";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import { MdOutlineCalendarMonth } from "react-icons/md";
import CategoryPopup from "./CategoryPopup";
import PlayersPopup from "./PlayerPopUp";
import { TimePicker } from 'antd';
import dayjs from "dayjs";

const AddCashInEntryForm = ({ isOpen, onClose, entryType, fetchExpenses }) => {
  const [parties, setParties] = useState([]);
  // const [category, setCategory] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isPlayerDropdownOpen, setIsPlayerDropdownOpen] = useState(false);
  // const [isCategoryPopupOpen, setIsCategoryPopupOpen] = useState(false);
  const [isPlayersPopupOpen, setIsPlayersPopupOpen] = useState(false);
  const partyDropdownRef = useRef(null);
  // const categoryDropdownRef = useRef(null);
  // const [editingCategoryId, setEditingCategoryId] = useState(null);
  // const [editingCategoryName, setEditingCategoryName] = useState("");
  // const [showEditModal, setShowEditModal] = useState(false);
  // const [deleteCategoryId, setDeleteCategoryId] = useState(null);
  // const [showDeleteModal, setShowDeleteModal] = useState(false);


  const formik = useFormik({
    initialValues: {
      date: new Date(),
      time: dayjs(),
      amount: "",
      playerName: "",
      remarks: "",
      // category: "",
      paymentMode: "Cash",
      // files: [],
    },
    validationSchema: Yup.object({
      date: Yup.date()
        .required("Date is required")
        .typeError("Invalid date"),
      time: Yup.mixed().required("Time is required"),
      amount: Yup.string()
        .required("Amount is required")
        .matches(/^\d+(\.\d{1,2})?$/, "Amount must be a positive number")
        .test(
          "is-positive",
          "Amount must be greater than zero",
          (value) => parseFloat(value) > 0
        ),
      // category: Yup.string()
      //   .required("Category is required"),
      playerName: Yup.string()
        .required("Party is required")
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        // const getCategoryIdByName = (name) => {
        //   const cat = category.find((c) => c.name === name);
        //   return cat ? cat.id : null;
        // };

        const getPartyIdByName = (name) => {
          const party = parties.find((p) => p.name === name);
          return party ? party.id : null;
        };

        const formData = new FormData();
        formData.append("expense[date]", values.date.toISOString().split("T")[0]);
        formData.append("expense[time]", values.time.format("HH:mm"));
        formData.append("expense[amount]", parseFloat(values.amount));
        formData.append("expense[details]", values.remarks);
        formData.append("expense[entry_type]", entryType);
        formData.append("expense[payment_mode]", values.paymentMode.toLowerCase());
        // formData.append("expense[expense_category_id]", getCategoryIdByName(values.category));
        formData.append("expense[party_id]", getPartyIdByName(values.playerName));

        // Attach files
        // if (values.files.length > 0) {
        //   Array.from(values.files).forEach((file) => {
        //     formData.append("expense[files][]", file);
        //   });
        // }

        const response = await apiService.post("/expenses", formData);
        onClose();
        toast.success("Cash In Entry added successfully!", { duration: 2000 });
        fetchExpenses();
        resetForm();
      } catch (errors) {
        handleError(errors);
      }
    },
  });

  const fetchParties = async () => {
    try {
      const response = await apiService.get("/parties");
      setParties(response.data);
    } catch (errors) {
      handleError(errors);
    }
  };

  // const fetchCategories = async () => {
  //   try {
  //     const response = await apiService.get("/expense_categories");
  //     setCategory(response.data);
  //   } catch (errors) {
  //     handleError(errors);
  //   }
  // };

  useEffect(() => {
    fetchParties();
    // fetchCategories();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isPlayerDropdownOpen &&
        partyDropdownRef.current &&
        !partyDropdownRef.current.contains(event.target)
      ) {
        setIsPlayerDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPlayerDropdownOpen, isDropdownOpen]);


  return (
    isOpen && (
      <>
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] relative">
            <div className="flex justify-between items-center mb-4">
              <h2 className={`text-lg font-semibold ${entryType === "cash_in" ? "text-green700" : "text-darkred"}`}>
                Add {entryType === "cash_in" ? "Cash In" : "Cash Out"} Entry
              </h2>
              <div
                className="absolute top-7 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px] flex justify-center items-center"
                onClick={() => {
                  formik.resetForm();
                  onClose();
                }}
              >
                <icons.IoClose className=" text-green700 text-xl" />
              </div>
            </div>

            <form onSubmit={formik.handleSubmit} className="space-y-4 max-h-[70vh] overflow-y-auto vertical">
              <div className="flex gap-4">
                <div className="flex-1">
                  <label className="block text-sm text-gray-600 mb-1">
                    Date <span className="text-red ">*</span>
                  </label>
                  <div className="relative">
                    <DatePicker
                      selected={formik.values.date}
                      onChange={(date) => formik.setFieldValue("date", date)}
                      dateFormat="dd MMM, yyyy"
                      className="inputtext w-full pr-10"
                    />
                    <MdOutlineCalendarMonth className="absolute right-3 top-2.5 text-blueButton pointer-events-none" />
                  </div>
                </div>
                <div className="flex-1">
                  <label className="block text-sm text-gray-600 mb-1">
                    Time <span className="text-red ">*</span>
                  </label>
                  <div className="w-full">
                    <TimePicker
                      value={formik.values.time}
                      format="hh:mm A"
                      use12Hours
                      allowClear={false}
                      inputReadOnly={true}
                      showNow={true}
                      popupClassName="custom-timepicker-popupok"
                      getPopupContainer={() => document.body}
                      onSelect={(time) => {
                        if (time) {
                          formik.setFieldValue("time", time);
                        }
                      }}
                      onBlur={() => formik.setFieldTouched("time", true)}
                      className="inputtext w-full focus:outline-none outline-none"
                    />

                  </div>
                  {formik.touched.time && formik.errors.time && (
                    <p className="text-red text-sm">{formik.errors.time}</p>
                  )}
                </div>
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  Amount <span className="text-red">*</span>
                </label>
                <input
                  type="text"
                  name="amount"
                  className="inputtext w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.amount}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
                  }}
                  placeholder="200 or 400"
                />

                {formik.touched.amount && formik.errors.amount && (
                  <p className="text-red text-sm">{formik.errors.amount}</p>
                )}
              </div>

              <div className="flex-1 relative">
                <div className="flex justify-between">
                  <label className="block text-sm text-gray-600 mb-1">
                    Party <span className="text-red">*</span>
                  </label>

                  {/* <div className="flex gap-2"><icons.FaRegEdit className="text-green" /> <icons.AiOutlineDelete className="text-red" /></div> */}
                </div>
                <button
                  type="button"
                  onClick={() => setIsPlayerDropdownOpen(!isPlayerDropdownOpen)}
                  className="inputtext w-full text-left"
                >
                  {formik.values.playerName || "Select party"}
                </button>

                {isPlayerDropdownOpen && (
                  <div ref={partyDropdownRef} className="absolute mt-1 z-20 w-full bg-white shadow border rounded ">
                    <div className="max-h-40 overflow-y-auto">
                      {parties?.length === 0 ? (
                        <div className="px-4 py-2 text-gray-500">
                          No Party found
                        </div>
                      ) : (
                        parties?.map((par) => (
                          <button
                            key={par.id}
                            onClick={() => {
                              formik.setFieldValue("playerName", par?.name);
                              setIsPlayerDropdownOpen(false);
                            }}
                            className="w-full text-left px-4 py-2 hover:bg-gray-50"
                          >
                            {par?.name}
                          </button>
                        ))
                      )}
                    </div>
                    <button
                      onClick={() => {
                        setIsPlayersPopupOpen(true);
                        setIsPlayerDropdownOpen(false);
                      }}
                      className="w-full text-left text-sm px-4 py-2 bg-G200 text-white font-medium border rounded-md"
                    >
                      + Add New Party
                    </button>
                  </div>
                )}
                {formik.touched.playerName && formik.errors.playerName && (
                  <p className="text-red text-sm">{formik.errors.playerName}</p>
                )}
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  Description
                </label>
                <input
                  type="text"
                  name="remarks"
                  className="inputtext w-full"
                  onChange={formik.handleChange}
                  value={formik.values.remarks}
                  placeholder="Enter details(Bills No,Name,Quantity)"
                />
              </div>

              <div className="flex flex-col sm:flex-row gap-0 space-y-4 sm:space-y-0 sm:gap-4">
                {/* <div className="flex-1 relative">
                  <div className="flex justify-between">
                    <label className="block text-sm text-gray-600 mb-1">
                      Category <span className="text-red">*</span>
                    </label>

                  </div>
                  <button
                    type="button"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    className="inputtext w-full text-left text-sm"
                  >
                    {formik.values.category || "Select category"}
                  </button>

                  {isDropdownOpen && (
                    <div ref={categoryDropdownRef} className="absolute mt-1 z-20 w-full bg-white shadow border rounded ">
                      <div className="max-h-40 overflow-y-auto">
                        {category.length === 0 ? (
                          <div className="px-4 py-2 text-gray-500">
                            No categories found
                          </div>
                        ) : (
                          category.map((cat) => (
                            <div key={cat.id} className="flex items-center justify-between px-4 py-2 border-b">
                              <span
                                onClick={() => {
                                  formik.setFieldValue("category", cat.name);
                                  setIsDropdownOpen(false);
                                }}
                                className="flex-1 cursor-pointer"
                              >
                                {cat.name}
                              </span>
                            </div>
                          ))

                        )}
                      </div>
                      <button
                        onClick={() => {
                          setIsCategoryPopupOpen(true);
                          setIsDropdownOpen(false);
                        }}
                        className="w-full text-left text-sm px-4 py-2 bg-G200 text-white  font-medium border"
                      >
                        + Add New Category
                      </button>
                    </div>
                  )}
                  {formik.touched.category && formik.errors.category && (
                    <p className="text-red text-sm">{formik.errors.category}</p>
                  )}

                </div>
                {showEditModal && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-4 w-96">
                      <h2 className="text-lg font-bold mb-4">Edit Category</h2>
                      <input
                        type="text"
                        value={editingCategoryName}
                        onChange={(e) => setEditingCategoryName(e.target.value)}
                        className="border w-full p-2 mb-4"
                      />
                      <div className="flex justify-end gap-3">
                        <button
                          onClick={() => {
                            setShowEditModal(false);
                            setEditingCategoryName("");
                            setEditingCategoryId(null);
                          }}
                          className="px-4 py-1 border rounded text-gray-600"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => handleCategoryUpdate(editingCategoryId)}
                          className="px-4 py-1 bg-green text-white rounded"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {showDeleteModal && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-4 w-80">
                      <h2 className="text-lg font-bold mb-4">Confirm Delete</h2>
                      <p>Are you sure you want to delete this category?</p>
                      <div className="flex justify-end gap-3 mt-4">
                        <button
                          onClick={() => setShowDeleteModal(false)}
                          className="px-4 py-1 border rounded text-gray-600"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => handleDeleteCategory(deleteCategoryId)}
                          className="px-4 py-1 bg-red text-white rounded"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                )} */}

                <div className="flex-1">
                  <label className="block text-sm text-gray-600 mb-1">
                    Payment Mode <span className="text-red ">*</span>
                  </label>
                  <select
                    name="paymentMode"
                    className="inputtext w-full"
                    onChange={formik.handleChange}
                    value={formik.values.paymentMode}
                  >
                    <option value="Cash">Cash</option>
                    {/* <option value="Card">Card</option>
                    <option value="UPI">UPI</option> */}
                  </select>
                </div>
              </div>
              {/* <div className="flex-1">

                <label className="block text-sm text-gray-600 mb-1">Attach Bill</label>
                <input
                  type="file"
                  name="files"
                  multiple
                  accept="image/*,application/pdf"
                  onChange={(event) => {
                    formik.setFieldValue("files", event.currentTarget.files);
                  }}
                  className="block w-full text-sm text-gray-700 file:mr-4 file:py-2 file:px-4 file:border-0 file:text-sm file:font-semibold file:bg-G30 file:text-G200 rounded-lg"
                />
              </div> */}


              <div className="flex justify-end gap-4 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    formik.resetForm();
                    onClose();
                  }}
                  className="w-[75px] sm:w-[93px] text-sm py-2 text-center border border-green text-green rounded-lg"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="w-[75px] sm:w-[93px] text-sm py-2 text-center  bg-green text-white rounded-lg"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* <CategoryPopup
          isOpen={isCategoryPopupOpen}
          onClose={() => setIsCategoryPopupOpen(false)}
          onCategorySuccess={fetchCategories}
       
        /> */}
        <PlayersPopup
          isOpen={isPlayersPopupOpen}
          onClose={() => setIsPlayersPopupOpen(false)}
          onPlayerSuccess={fetchParties}
        />
      </>
    )
  );
};

export default AddCashInEntryForm;
